import { createAction } from '../../../../../store.model';
import { ActionType } from '../main.action';

export interface SortRows {
    columnId: string;
}

export const sortRows = createAction<ActionType, SortRows>(
    ActionType.WP_MAIN__SORT_ROWS,
);
